import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=437f6e54&scoped=true"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f6e54",
  null
  
)

export default component.exports